import React from 'react';
import PropTypes from 'prop-types';
/* eslint no-unused-vars: [2, { "varsIgnorePattern": "[IconConstants]" }] */
import IconConstants from 'components/shared/icons/IconConstants';
import provideTranslations from 'decorators/provideTranslations';

@provideTranslations('Icons')
class CaretContainer extends React.Component {
  render() {
    return <CaretIcon {...this.props} />;
  }
}

class CaretIcon extends React.Component {
  static propTypes = {
    color: PropTypes.string,
    direction: PropTypes.string,
    size: PropTypes.number,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  static defaultProps = {
    color: IconConstants.DARK_GREY,
    direction: 'down',
    size: 12,
  };

  static directions = {
    up: {
      title: 'AA_Caret_Up_Icon_Title',
      desc: 'AA_Caret_Up_Icon_Desc',
      rotate: 180,
    },
    right: {
      title: 'AA_Caret_Right_Icon_Title',
      desc: 'AA_Caret_Right_Icon_Desc',
      rotate: 270,
    },
    down: {
      title: 'AA_Caret_Down_Icon_Title',
      desc: 'AA_Caret_Down_Icon_Desc',
      rotate: 0,
    },
    left: {
      title: 'AA_Caret_Left_Icon_Title',
      desc: 'AA_Caret_Left_Icon_Desc',
      rotate: 90,
    },
  }

  render() {
    const { getString } = this.context;
    const {
      color,
      direction,
      size,
    } = this.props;

    const caretDirection = CaretIcon.directions[direction];

    return (
      <svg width={size} height="100%" viewBox="0 0 12 12" role="img" aria-label={getString(caretDirection.desc) || 'A Caret Icon Pointing'}>
        <title>{getString(caretDirection.title) || 'Caret Icon'}</title>
        <desc>{getString(caretDirection.desc) || 'A Caret Icon Pointing'}</desc>
        <polygon
          role="presentation"
          stroke="none"
          fill={color}
          fillRule="evenodd"
          transform={`rotate(${caretDirection.rotate} 6 6)`}
          points="10.6,2 6,6.6 1.4,2 0,3.4 6,9.4 12,3.4"
        />
      </svg>
    );
  }
}

export default CaretContainer;
